import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import axiosInstance from "../../commons/AxiosInstance.ts";

export abstract class HttpClient {
  protected instance: AxiosInstance = axiosInstance;
}
export interface ITenantConfig {
  culture: string;
  dateFormat: string;
  dateTimeFormat: string;
  tenantId?: string;
  timeFormat: string;
  timeZone: string;
}
export class HttpClientNormal extends HttpClient {
  private readonly timezone: string;

  constructor() {
    super();
    const tenantConfig: ITenantConfig = JSON.parse(localStorage.getItem("tenant_config") || "{}");
    this.timezone = tenantConfig.timeZone || "";
  }

  async get(url: string, options?: AxiosRequestConfig): Promise<AxiosResponse> {
    let headers: Record<string, string>;
    if (this.timezone) {
      headers = { timezone: this.timezone };
    } else {
      headers = {};
    }
    const optionsCustom: AxiosRequestConfig = {
      ...options,
      headers
    };
    return await this.instance.get(url, optionsCustom);
  }

  async post(url: string, data: any = {}, options?: AxiosRequestConfig): Promise<AxiosResponse> {
    let headers: Record<string, string> | any;
    if (this.timezone) {
      headers = {
        "Content-Type": "application/json",
        timezone: this.timezone,
        ...(options?.headers || {})
      };
    } else {
      headers = {
        "Content-Type": "application/json",
        ...(options?.headers || {})
      };
    }

    let requestData: any = data;
    if (typeof data === "string") {
      requestData = JSON.stringify(data);
    }

    const optionsCustom: AxiosRequestConfig = {
      ...options,
      headers,
      transformRequest: [
        (data: any) => {
          if (typeof data === "string") {
            return data;
          }
          return JSON.stringify(data);
        }
      ]
    };

    return await this.instance.post(url, requestData, optionsCustom);
  }

  async put(url: string, data: object = {}, options?: AxiosRequestConfig): Promise<AxiosResponse> {
    let headers: Record<string, string>;
    if (this.timezone) {
      headers = { timezone: this.timezone };
    } else {
      headers = {};
    }
    const optionsCustom: AxiosRequestConfig = {
      ...options,
      headers
    };
    return await this.instance.put(url, data, optionsCustom);
  }

  async patch(
    url: string,
    data: object = {},
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse> {
    let headers: Record<string, string>;
    if (this.timezone) {
      headers = { timezone: this.timezone };
    } else {
      headers = {};
    }
    const optionsCustom: AxiosRequestConfig = {
      ...options,
      headers
    };
    return await this.instance.patch(url, data, optionsCustom);
  }

  async delete(url: string, options?: AxiosRequestConfig): Promise<AxiosResponse> {
    let headers: Record<string, string> = {};
    if (this.timezone) {
      headers = { timezone: this.timezone };
    }
    const optionsCustom: AxiosRequestConfig = {
      ...options,
      headers
    };
    return await this.instance.delete(url, optionsCustom);
  }
}
